import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { classNames } from 'uitk-react-utils';

export interface LeadPriceProps {
  lead?: string;
  label?: string;
  priceFontWeight: string;
  wrapPrice: boolean;
  strikeOut?: string;
  viewed: boolean;
}

export const LeadPrice: React.FunctionComponent<LeadPriceProps> = ({ lead, label, priceFontWeight, wrapPrice, strikeOut, viewed }) => {
  if (!lead) {
    return null;
  }
  const classes = classNames(`uitk-cell uitk-type-${priceFontWeight} uitk-type-bold`, {
    'all-cell-shrink': !wrapPrice,
    'm-cell-shrink l-cell-shrink xl-cell-shrink': wrapPrice,
    'pwa-theme--grey-700': viewed,
  });

  return (
    <span className={`${classes}`} data-stid="content-hotel-display-price">
      <span className="is-visually-hidden">
        <LocalizedText
          message={strikeOut ? 'hotels.infosite.rateInfoDialog.leadWithStrikeOutPresent' : 'hotels.infosite.rateInfoDialog.lead'}
          data={[lead]}
        />
      </span>
      <span data-stid="price-lockup-text" aria-hidden="true">
        {lead}
      </span>
      {label && (
        <span className="uitk-type-400 uitk-type-regular pwa-theme--grey-900" data-stid="lead-price--text">
          {label}
        </span>
      )}
    </span>
  );
};
